import axiosApi from "shared/api/axiosApi";
import { checkCurrentLanguage } from "shared/lib/checkCurrentLanguage";
import {
  GetMarathonInsurancesByMarathonIdIdRes,
  GetMarathonInsurancesByMarathonIdParams,
  PostInsurancesBody,
  PostInsurancesResponse,
  PostPurchaseInsurancesBody,
  PostPurchaseInsurancesRes,
} from "./types";

export const insuranceAgreementsAPI = {
  getMarathonInsurancesByMarathonId: async (
    params: GetMarathonInsurancesByMarathonIdParams
  ): Promise<GetMarathonInsurancesByMarathonIdIdRes> => {
    const response = await axiosApi.get<GetMarathonInsurancesByMarathonIdIdRes>(
      `/insurances/marathon/${params.marathonId}/insurances`,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postInsurances: async (
    body: PostInsurancesBody
  ): Promise<PostInsurancesResponse> => {
    const response = await axiosApi.post<PostInsurancesResponse>(
      "/insurances",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
  postPurchaseInsurances: async (
    body: PostPurchaseInsurancesBody
  ): Promise<PostPurchaseInsurancesRes> => {
    const response = await axiosApi.post<PostPurchaseInsurancesRes>(
      "/insurances/purchase",
      body,
      {
        headers: {
          "Accept-Language": checkCurrentLanguage(),
        },
      }
    );
    return response.data;
  },
};
